import { PersonAvatar } from '../../models/avatar.model';
import { Nationality } from '../../models/nationality.model';
import { MaritalStatus } from '../marital-statuses/marital-status.model';
import { User } from '../../models/user.model';
import { RelationConfig } from '../relation-config';

export interface Person {
  id?: string;
  avatar?: PersonAvatar | null;
  email?: string | null;
  first_name: string;
  middle_name: string;
  last_name: string;
  phone_number: string;
  mobile_number: string;
  date_of_birth: string;
  marital_status: MaritalStatus;
  gender: string; // Enum actually (male, female)
  bsn: string;
  nationality: Nationality;
  user: User | null;
  relation: RelationConfig;
  relation_configuration_id: string | number;
  nationality_configuration_id: string | number;
  household_id: number;
  // added by joseph (03-27-20)
  education_configuration_id: string | number;
  smokes: boolean;
  quit_smoking: boolean;
  bmi: string;
  length: number;
  weight: number;
}

export function createPerson(params: Partial<Person>) {
  return {
    gender: 'MALE',
    nationality_configuration_id: 158,
    relation_configuration_id: 434,
    date_of_birth: '2020-01-09',
    household_id: 1
  } as Person;
}
